'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ActionTypes = require('conversations-core/constants/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _PubNubStatusCategories = require('conversations-core/constants/PubNubStatusCategories');

var PubNubStatusCategories = _interopRequireWildcard(_PubNubStatusCategories);

var _pubNubStatusSelectors = require('conversations-core/selectors/pubNubStatusSelectors');

var _PubNubStatusActions = require('conversations-core/actions/PubNubStatusActions');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var OFFLINE_BUFFER_MILLISECONDS = 30000;

var offlineTimeout = null;

function createNetworkOfflineTimeout(dispatch) {
  return setTimeout(function () {
    offlineTimeout = null;
    dispatch((0, _PubNubStatusActions.networkOffline)());
  }, OFFLINE_BUFFER_MILLISECONDS);
}

exports.default = _defineProperty({}, _ActionTypes2.default.RECEIVED_PUBNUB_STATUS, function (action, getState, dispatch) {
  var category = action.payload.category;


  switch (category) {
    case PubNubStatusCategories.NETWORK_DOWN:
      if (offlineTimeout) {
        break;
      }
      offlineTimeout = createNetworkOfflineTimeout(dispatch);
      break;
    case PubNubStatusCategories.NETWORK_UP:
      if (offlineTimeout) {
        clearTimeout(offlineTimeout);
        offlineTimeout = null;
      }
      if ((0, _pubNubStatusSelectors.getIsVisiblyOffline)(getState())) {
        dispatch((0, _PubNubStatusActions.networkOnline)());
      }
      break;
    default:
      return;
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/pubNubHandlers/statusHandlers.js
// module id = 502
// module chunks = 0